import * as React from 'react';
import { useTranslationHook } from 'PyzShopUi/scripts/utils/translationHook';
import ReadMoreHandler from 'PyzShopUi/scripts/modules/readMore';

const maxLineCount = 8;

export const SuitableBikes = props => {
    const { bikes } = props;
    const { translate } = useTranslationHook();
    const [isReadMoreOpen, setIsReadMoreOpen] = React.useState(false);

    React.useEffect(() => {
        if (bikes.length > 0) {
            ReadMoreHandler.init((isOpen) => setIsReadMoreOpen(isOpen));
        }
    }, []);


    if (bikes.length === 0) {
        return null;
    }

    return (
        <>
            <h3>{translate('List of compatible motorcycles', { ns: 'article-detail' })}</h3>

            {bikes.length > 6 ?
                <>
                    <div data-read-more-max-line={maxLineCount} className="read-more">
                        <div className="read-more__text">
                            <ul>
                            {
                                bikes.map((bike, i) => {
                                    const bikeLinkText = (bike.model.trim().length) ? bike.name + " (" + bike.model + ")" : bike.name;

                                    return (
                                        <li key={bike.bike_id}>
                                            <p>
                                                <a href={bike.url} tabIndex={i >= maxLineCount - 2 && !isReadMoreOpen ? -1 : 0}>{bikeLinkText}</a>
                                            </p>
                                        </li>
                                    );
                                })
                            }
                            </ul>
                            <div className="read-more__text__gradient"></div>
                        </div>
                        <span
                            data-read-more-open="false"
                            className="read-more__button"
                            tabIndex={0}
                            role='button'
                        />
                    </div>
                </> :
                <>
                    <ul>
                    {
                        bikes.map(bike => {
                            const bikeLinkText = (bike.model.trim().length) ? bike.name + " (" + bike.model + ")" : bike.name;

                            return (
                                <li key={bike.bike_id}>
                                    <a href={bike.url}>{bikeLinkText}</a>
                                </li>
                            );
                        })
                    }
                    </ul>
                </>
            }
        </>
    );
};
